import React, { useEffect, useState } from 'react'
import { validateValue } from '../../login/Validations';
import { useForm } from "../../../components/forms/Form";
import styles from './authentication.module.css'
import { useAppContext } from "../../../components/activity/AppContext";
import AuthenticationActions from './authentication.actions';
import CustomAuth from './customAuth';
import OAuth from './oAuth';
import { useLocation } from 'react-router-dom';
import UserMapping from './UserMapping';
import { ModuleTitle } from '../../../components/module-title';
import AuthenticationPopUp from './autenticationPopUp';
import Pagination from '../../../components/Pagination/pagination';
import Table from '../../../components/Table/table';

export default function Authentication({perm}) {
    const [authMasterData, setAuthMasterData] = useState([]);
    const [currentAuthData, setCurrentAuthData] = useState({});
    const [editData, setEditData] = useState({ id: "", name: "", config: "",entityId:""});
    const [state,setState] = useState(0)
    const forceRefresh = () => setState(state + 1);
    const [submit, setSubmit] = useState(true);
    const [disableTextarea, setDisableTextarea] = useState(false)
    const [popUp, setPopUp] = useState(false);
    const app = useAppContext();
    const location = useLocation();
    location.state = {permission:perm}

    const [totalRecords,setTotalRecords] = useState(0);
    const [displayRows, setDisplayRows] = useState({
        offset: 0,
        limit: 10
    });
    const [isEdit, setEdit] = useState(false);
    const [buttonName1, setButtonName1] = useState("Cancel");
    const [buttonName2, setButtonName2] = useState("Save");
    const [enableState,setEnableState] = useState(0);

    const getAuthenticationMasterData = async () => {
        const actions = AuthenticationActions(app());
        const [, masterData] = await actions.getAuthentications();
        if(masterData)
        setAuthMasterData(masterData?.data);
    }

    const getAuthenticationCurrentData = async () => {
        const actions = AuthenticationActions(app());
        const [, data] = await actions.readAuthenticationData();
        if(data){
            setCurrentAuthData(data?.data);
            setTotalRecords(data?.noOfRecords)
        }
    }
    
    const updatePrimary = async (id) => {
        const actions = AuthenticationActions(app());
        const [_,data]= await actions.UpdatePrimaryData(id);
        return data
    }

    const deleteAuth = async (id) => {
        const actions = AuthenticationActions(app());
        const res = await actions.DeleteAuth(id);
        forceRefresh()
    }
    
    const editAuth = async (id) => {
        const actions = AuthenticationActions(app());
        const [err,res] = await actions.EditAuth(id);
        return res?.detail;
    }

    const fetchAuthenticationData = () => {
        getAuthenticationMasterData();
        getAuthenticationCurrentData();
    }

    useEffect(() => fetchAuthenticationData(), [state]);

    const deleteAdapter = async (value) =>{
        // console.log("value",value)
        await deleteAuth(value.id)

    }

    const editAdapter = async (value) =>{
        const res =  await editAuth(value.id);
       setEditData({...res,id:value.id});
    }

    const getContextMenu = (item) => {
        let cont = []
        if(location.state.permission?.canUpdate) cont.push('Edit')
        // if(location.state.permission?.canDelete) 
        if(!item.isActive)  cont.push('Delete')
     
       
        return cont;
      }
      const contextOnChange = (option, value) => {
        switch (option) {
          case 'Edit':
            setEdit(true)
            setButtonName1("Cancel");
            setButtonName2("Update");
            setPopUp(true);
            editAdapter(value)
            // editAdapter(value.name, value.type);
            // setModifyAdapter(value);
            // if (value.type === "SAP ERP") setModifyAdapter({ ...value, type: "ECC" });
            // else setModifyAdapter(value);
            break;
          case 'Delete':
             deleteAdapter(value);
            break; 
          default:
            break;
        }
      }

      const handleImagePopup = async (res, item) => {
        const resi = await updatePrimary(item?.id);
        if (resi) {
            await fetchAuthenticationData(); 
            forceRefresh(); 
        }
    };
    
    const initialAuthenticationArray = [
        { id: "name", name: "Name", type: "input" , disabled:true },
        { id: "description", name: "Description", type: "input",disabled:true },
        { id: "authName", name: "Authentication Type", type: "input",disabled:true },
        {
            id: "isActive",
            name: "isActive",
            icon: true,
            handleImagePopup: handleImagePopup
          },
        { id: "moreVertIcon", name: "moreVertIcon",  type: "moreVertIcon" }
    ]

 

    const handleClosePopup = ()=>{
        setEdit(false)
        setEditData({ id: "", name: "", config: "",entityId:""})
        setPopUp(false)
        forceRefresh()
    }

    useEffect(() => {
        if (Array.isArray(currentAuthData)) {
          const hasFMAuthType = currentAuthData.some(
            (item) => item.authName === "FM Authentication"
          );
      
          if (hasFMAuthType) {
            setAuthMasterData((prevAuthMasterData) =>
              prevAuthMasterData.filter((item) => item.name !== "FM Authentication")
            );
          }
        }
      }, [currentAuthData,popUp]);
      
      

  
    return (
        <div className={styles.authContainer}>
                <ModuleTitle 
                    title="Authentication" 
                    subTitle="Admin Tools"
                >
                {
                    // location.state.permission?.canCreate
                    // ?
                    <button 
                        className={'primary'}
                        data-clickable-testid={'New Auth'} 
                        onClick={() => setPopUp(true)}
                    >
                        + New Auth
                    </button>
                    // :<></>
                }
                </ModuleTitle>
                <div className="afModule">
                <Table
                    key={state}
                    data={currentAuthData}
                    headerColumns={initialAuthenticationArray}
                    modifyPopUp={getContextMenu}
                    contextOnChange={contextOnChange}

                // handleHeaderInputChange={(id, value) => onChange(id, value)}
                // handleHeaderSelectChange={(id, value) => onChange(id, value)}
                />
                <Pagination
                    userDataCount={totalRecords}
                    displayRows={displayRows}
                    setDisplayRows={setDisplayRows} 
                />
                <AuthenticationPopUp 
                    popUp={popUp} 
                    setPopUp={handleClosePopup}
                    isEdit={isEdit}
                    setEdit={setEdit} 
                    buttonName1={buttonName1} 
                    buttonName2={buttonName2}
                    authMasterData={authMasterData}
                    perm={location.state.permission}
                    editData={editData}
                />
                </div>
        </div >
    )
}
